__turbopack_context__.v({
  "root": "service-form-module-scss-module___h43jW__root",
  "title": "service-form-module-scss-module___h43jW__title",
});
